// Module
var code = "<template><label>${searchText}</label> <input class=\"entity-finder search-bar\" type=\"text\" value.two-way=\"filter\"> <button class=\"primary\" click.delegate=\"onSubmit()\">Search</button></template>";
// Exports
module.exports = code;